<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="con">
<a id="page06"></a>
<h2 class="contentsHead"><span class="bold">Contents</span></h2>
<div class="contentsEntry1"><p class="contentsEntryName1"><span href="#/epigraph#epg" title="Link target outside of Sample">Epigraph</span></p></div>
<div class="contentsEntry1"><p class="contentsEntryName1" id="ack_01"><a href="#/acknowledgments#ack01">Acknowledgments</a></p></div>
<div class="contentsEntry1"><p class="contentsEntryName1" id="atn_01"><a href="#/authorsnote#atn01">Author’s Note</a></p></div>
<br/>
<table>
<tbody><tr><td style="width:18%;"> </td>
<td style="width:20%;" valign="top"><div class="contentsEntry"><p class="contentsEntryName1"><a href="#/prologue"><span class="smallCaps">PROLOGUE</span></a></p></div></td>
<td valign="top"><div class="contentsEntry"><p class="contentsEntryName1" id="pro_01"><a href="#/prologue#pro01">Go Forward</a></p></div></td>
</tr>
</tbody></table>
<div class="contentsEntry1"><p class="contentsEntryName1" id="pt_01"><a href="#/part01#pt01"><span class="bold">P<span class="smallCaps">ART</span> O<span class="smallCaps">NE</span></span></a></p>
</div>
<table>
<tbody><tr>
<td style="width:18%;"> </td>
<td style="width:20%;" valign="top">
<div class="contentsEntry"><p class="contentsEntryName1"><a href="#/chapter01#ch01">
<span class="smallCaps">CHAPTER 1</span></a></p></div></td>
<td valign="top"><div class="contentsEntry"><p class="contentsEntryName1" id="ch_01"><a href="#/chapter01#ch01">Candy</a></p></div></td>
</tr>
<tr><td style="width:18%;"> </td>
<td style="width:20%;" valign="top"><div class="contentsEntry"><p class="contentsEntryName1"><span href="#/chapter02#ch02" title="Link target outside of Sample">
<span class="smallCaps">CHAPTER 2</span></span></p></div></td>
<td valign="top"><div class="contentsEntry"><p class="contentsEntryName1" id="ch_02"><span href="#/chapter02#ch02" title="Link target outside of Sample">The No-Daddy Blues</span></p></div></td>
</tr>
<tr><td style="width:18%;"> </td>
<td style="width:20%;" valign="top"><div class="contentsEntry"><p class="contentsEntryName1"><span href="#/chapter03#ch03" title="Link target outside of Sample">
<span class="smallCaps">CHAPTER 3</span></span></p></div></td>
<td valign="top"><div class="contentsEntry"><p class="contentsEntryName1" id="ch_03"><span href="#/chapter03#ch03" title="Link target outside of Sample">Where’s Momma?</span></p></div></td>
</tr>
<tr><td style="width:18%;"> </td>
<td style="width:20%;" valign="top"><div class="contentsEntry"><p class="contentsEntryName1"><span href="#/chapter04#ch04" title="Link target outside of Sample">
<span class="smallCaps">CHAPTER 4</span></span></p></div></td>
<td valign="top"><div class="contentsEntry"><p class="contentsEntryName1" id="ch_04"><span href="#/chapter04#ch04" title="Link target outside of Sample">Bitches Brew (side a)</span></p></div></td>
</tr>
<tr><td style="width:18%;"> </td>
<td style="width:20%;" valign="top"><div class="contentsEntry"><p class="contentsEntryName1"><span href="#/chapter05#ch05" title="Link target outside of Sample">
<span class="smallCaps">CHAPTER 5</span></span></p></div></td>
<td valign="top"><div class="contentsEntry"><p class="contentsEntryName1" id="ch_05"><span href="#/chapter05#ch05" title="Link target outside of Sample">Bitches Brew (side b)</span></p></div></td>
</tr>
</tbody></table>
<div class="contentsEntry1"><p class="contentsEntryName1" id="pt_02"><span href="#/part02#pt02" title="Link target outside of Sample"><span class="bold">P<span class="smallCaps">ART</span> T<span class="smallCaps">WO</span></span></span></p></div>
<table>
<tbody><tr><td style="width:18%;"> </td>
<td style="width:20%;" valign="top"><div class="contentsEntry"><p class="contentsEntryName1"><span href="#/chapter06#ch06" title="Link target outside of Sample">
<span class="smallCaps">CHAPTER 6</span></span></p></div></td>
<td valign="top"><div class="contentsEntry"><p class="contentsEntryName1" id="ch_06"><span href="#/chapter06#ch06" title="Link target outside of Sample">The World Beyond</span></p></div></td>
</tr>
<tr><td style="width:18%;"> </td>
<td style="width:20%;" valign="top"><div class="contentsEntry"><p class="contentsEntryName1"><span href="#/chapter07#ch07" title="Link target outside of Sample">
<span class="smallCaps">CHAPTER 7</span></span></p></div></td>
<td valign="top"><div class="contentsEntry"><p class="contentsEntryName1" id="ch_07"><span href="#/chapter07#ch07" title="Link target outside of Sample">Pictures of a Life</span></p></div></td>
</tr>
<tr><td style="width:18%;"> </td>
<td style="width:20%;" valign="top"> </td>
<td valign="top"><div class="contentsEntry"><p class="contentsEntryName1" id="phi_01"><span href="#/chapter07a#phi01" title="Link target outside of Sample">Photographic Insert</span></p></div></td>
</tr>
<tr><td style="width:18%;"> </td>
<td style="width:20%;" valign="top"><div class="contentsEntry"><p class="contentsEntryName1"><span href="#/chapter08#ch08" title="Link target outside of Sample">
<span class="smallCaps">CHAPTER 8</span></span></p></div></td>
<td valign="top"><div class="contentsEntry"><p class="contentsEntryName1" id="ch_08"><span href="#/chapter08#ch08" title="Link target outside of Sample">Turned Out (an intro)</span></p></div></td>
</tr>
<tr><td style="width:18%;"> </td>
<td style="width:20%;" valign="top"><div class="contentsEntry"><p class="contentsEntryName1"><span href="#/chapter09#ch09" title="Link target outside of Sample"><span class="smallCaps">CHAPTER 9</span></span></p></div></td>
<td valign="top"><div class="contentsEntry"><p class="contentsEntryName1" id="ch_09"><span href="#/chapter09#ch09" title="Link target outside of Sample">Turned Out (advanced)</span></p></div></td>
</tr>
<tr><td style="width:18%;"> </td>
<td style="width:20%;" valign="top"><div class="contentsEntry"><p class="contentsEntryName1"><span href="#/chapter10#ch10" title="Link target outside of Sample">
<span class="smallCaps">CHAPTER 10</span></span></p></div></td>
<td valign="top"><div class="contentsEntry"><p class="contentsEntryName1" id="ch_10"><span href="#/chapter10#ch10" title="Link target outside of Sample">California Dreamin’</span></p></div></td>
</tr>
</tbody></table>
<div class="contentsEntry1"><p class="contentsEntryName1" id="pt_03"><span href="#/part03#pt03" title="Link target outside of Sample"><span class="bold">P<span class="smallCaps">ART</span> T<span class="smallCaps">HREE</span></span></span></p></div>
<table>
<tbody><tr><td style="width:18%;"> </td>
<td style="width:20%;" valign="top"><div class="contentsEntry"><p class="contentsEntryName1"><span href="#/chapter11#ch11" title="Link target outside of Sample">
<span class="smallCaps">CHAPTER 11</span></span></p></div></td>
<td valign="top"><div class="contentsEntry"><p class="contentsEntryName1" id="ch_11"><span href="#/chapter11#ch11" title="Link target outside of Sample">Roses in the Ghetto</span></p></div></td>
</tr>
<tr><td style="width:18%;"> </td>
<td style="width:20%;" valign="top"><div class="contentsEntry"><p class="contentsEntryName1"><span href="#/chapter12#ch12" title="Link target outside of Sample">
<span class="smallCaps">CHAPTER 12</span></span></p></div></td>
<td valign="top"><div class="contentsEntry"><p class="contentsEntryName1" id="ch_12"><span href="#/chapter12#ch12" title="Link target outside of Sample">Sphere of Influence</span></p></div></td>
</tr>
<tr><td style="width:18%;"> </td>
<td style="width:20%;" valign="top"><div class="contentsEntry"><span href="#/epilogue" title="Link target outside of Sample">
<span class="smallCaps">EPILOGUE</span></span></div></td>
<td valign="top"><div class="contentsEntry" id="epi_01"><span href="#/epilogue#epi01" title="Link target outside of Sample">Blessed Beyond the Dreams of a Thousand Men</span></div></td>
</tr>
</tbody></table>
<div class="contentsEntry1">
<p class="contentsEntryName1" id="ata_01"><span href="#/abouttheauthor#ata01" title="Link target outside of Sample">About the Authors</span></p>
</div>
<div class="contentsEntry1">
<p class="contentsEntryName1" id="crd_01"><span href="#/credits#crd01" title="Link target outside of Sample">Credits</span></p>
</div>
<div class="contentsEntry1">
<p class="contentsEntryName1" id="cop_01"><span href="#/copyright#cop" title="Link target outside of Sample">Copyright</span></p>
</div>
<div class="contentsEntry1">
<p class="contentsEntryName1" id="atp_01"><span href="#/aboutthepublisher#atp01" title="Link target outside of Sample">About the Publisher</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?33c845f0